// import com.razz.types.monetary.KnownCurrencies
// KnownCurrencies.CURRENCIES.values.joinToString(
//     prefix = "{",
//     postfix = "}",
//     separator = ", "
// ) { "'${it.currencyCode}': ${it.fractionDigits}" }
export const currencyFractionDigits: Record<string, number> = {
  THB: 2,
  JMD: 2,
  GTQ: 2,
  IRR: 2,
  USN: 2,
  BDT: 2,
  SYP: 2,
  NIO: 2,
  ETB: 2,
  KYD: 2,
  XPD: -1,
  COU: 2,
  BHD: 3,
  HKD: 2,
  PAB: 2,
  CUC: 2,
  GIP: 2,
  LKR: 2,
  XBD: -1,
  MXV: 2,
  FIM: 2,
  XOF: 0,
  KHR: 2,
  BMD: 2,
  BWP: 2,
  SLE: 2,
  TMT: 2,
  PYG: 0,
  CRC: 2,
  LTL: 2,
  TND: 3,
  HNL: 2,
  MMK: 2,
  XAF: 0,
  FKP: 2,
  AMD: 2,
  ZWN: 2,
  XPT: -1,
  VEB: 2,
  CYP: 2,
  AED: 2,
  AWG: 2,
  KRW: 0,
  USD: 2,
  FRF: 2,
  STN: 2,
  LYD: 3,
  KPW: 2,
  GBP: 2,
  TZS: 2,
  AZN: 2,
  RSD: 2,
  SDD: 2,
  RWF: 0,
  DEM: 2,
  VED: 2,
  AOA: 2,
  EUR: 2,
  LBP: 2,
  SLL: 2,
  UYI: 0,
  MVR: 2,
  KWD: 3,
  TRY: 2,
  NOK: 2,
  GHS: 2,
  MKD: 2,
  SRG: 2,
  SOS: 2,
  BGL: 2,
  XDR: -1,
  ZMK: 2,
  MGA: 2,
  AUD: 2,
  MRO: 2,
  UZS: 2,
  NAD: 2,
  BOV: 2,
  SKK: 2,
  SAR: 2,
  COP: 2,
  KZT: 2,
  CZK: 2,
  AZM: 2,
  BRL: 2,
  MYR: 2,
  AFA: 2,
  ESP: 0,
  ALL: 2,
  PTE: 0,
  XFO: -1,
  XBA: -1,
  LAK: 2,
  KMF: 0,
  PHP: 2,
  BBD: 2,
  NZD: 2,
  MTL: 2,
  CUP: 2,
  DZD: 2,
  TMM: 2,
  XBB: -1,
  AFN: 2,
  PGK: 2,
  MWK: 2,
  XXX: -1,
  IEP: 2,
  DOP: 2,
  LUF: 0,
  XAU: -1,
  ISK: 0,
  SBD: 2,
  GNF: 0,
  ZWR: 2,
  NLG: 2,
  PKR: 2,
  DKK: 2,
  BIF: 0,
  CDF: 2,
  MOP: 2,
  CAD: 2,
  MUR: 2,
  BAM: 2,
  TPE: 0,
  VEF: 2,
  GEL: 2,
  RUB: 2,
  BSD: 2,
  ERN: 2,
  VUV: 0,
  SRD: 2,
  GWP: 2,
  LVL: 2,
  USS: 2,
  SZL: 2,
  CSD: 2,
  XCD: 2,
  GHC: 2,
  RON: 2,
  NGN: 2,
  IQD: 3,
  JPY: 0,
  BYB: 0,
  LRD: 2,
  JOD: 3,
  UYU: 2,
  SHP: 2,
  CLP: 0,
  MXN: 2,
  ZWD: 2,
  BOB: 2,
  ITL: 0,
  BYN: 2,
  ZAR: 2,
  PEN: 2,
  KES: 2,
  TTD: 2,
  ZWL: 2,
  TJS: 2,
  MZN: 2,
  GYD: 2,
  BGN: 2,
  BND: 2,
  INR: 2,
  XTS: -1,
  RUR: 2,
  HUF: 2,
  UGX: 0,
  BEF: 0,
  ATS: 2,
  TRL: 0,
  XBC: -1,
  AYM: 2,
  DJF: 0,
  SGD: 2,
  HTG: 2,
  CVE: 2,
  PLN: 2,
  BTN: 2,
  XAG: -1,
  KGS: 2,
  CHE: 2,
  MAD: 2,
  TWD: 2,
  NPR: 2,
  ADP: 0,
  YUM: 2,
  XCG: 2,
  VND: 0,
  XSU: -1,
  CLF: 4,
  ILS: 2,
  MGF: 0,
  EEK: 2,
  UAH: 2,
  ZWG: 2,
  BYR: 0,
  ARS: 2,
  CHF: 2,
  QAR: 2,
  WST: 2,
  GRD: 0,
  GMD: 2,
  OMR: 3,
  MNT: 2,
  YER: 2,
  ZMW: 2,
  SDG: 2,
  STD: 2,
  XFU: -1,
  MRU: 2,
  SSP: 2,
  FJD: 2,
  CNY: 2,
  SVC: 2,
  HRK: 2,
  MDL: 2,
  BZD: 2,
  TOP: 2,
  SCR: 2,
  LSL: 2,
  ROL: 0,
  SEK: 2,
  XPF: 0,
  VES: 2,
  SIT: 2,
  IDR: 2,
  MZM: 2,
  EGP: 2,
  ANG: 2,
  CHW: 2,
  XUA: -1,
  BTC: 8,
  ETH: 8,
  TRX: 6,
  BNB: 8,
  MATIC: 8,
  ARB: 8,
  ADA: 6,
  XTZ: 6,
  ATOM: 6,
  ISLM: 8,
  SOL: 9,
  TON: 9,
  USDT: 6,
  USDC: 6,
  EURT: 6,
  EURA: 6,
  EURC: 6,
  XRP: 6,
  NPC: 6,
  DOGE: 6,
  PEPE: 6,
  SHIB: 6,
  TRUMP: 6,
};

// import com.razz.types.monetary.CryptoCurrencies
// CryptoCurrencies.enumerate().toList().joinToString { "'${it.currencyCode}'" }
export const cryptoCurrencies = new Set([
  'BTC',
  'ETH',
  'TRX',
  'BNB',
  'MATIC',
  'ARB',
  'ADA',
  'XTZ',
  'ATOM',
  'ISLM',
  'SOL',
  'TON',
  'USDT',
  'USDC',
  'EURT',
  'EURA',
  'EURC',
  'XRP',
  'NPC',
  'DOGE',
  'PEPE',
  'SHIB',
  'TRUMP',
]);

export const fiatCurrencies = new Set(
  Object.keys(currencyFractionDigits).filter((currency) => !cryptoCurrencies.has(currency)),
);
